import { INSURANCE_TYPE } from '@orcar/common-d2c';
import { getInsuranceName } from '@/utils/insurance';

export const INSURANCE_BUTTONS = [
  {
    id: INSURANCE_TYPE.NORMAL,
    label: getInsuranceName(INSURANCE_TYPE.NORMAL),
  },
  {
    id: INSURANCE_TYPE.PERFECT,
    label: getInsuranceName(INSURANCE_TYPE.PERFECT),
  },
  {
    id: INSURANCE_TYPE.SUPER,
    label: getInsuranceName(INSURANCE_TYPE.SUPER),
  },
];
export const INSURANCE_RANGE = [
  {
    insurance: '일반자차',
    info: '최소한의 보장만 필요하다면',
    range: [
      ': 수리비 20%(최저 30~50만원), 면책금 30만원',
      ': 보장 불가',
      ': 내 보상',
      ': 수리비 20%(최저 30~50만원), 면책금 30만원, 휴차보상료 발생',
      ': 불가',
    ],
    xPosition: '35px',
  },
  {
    insurance: '고급자차',
    info: '운전이 익숙해도 왠지 불안하다면',
    range: [
      ': 면책금 30만원',
      ': 보상한도 초과 시 발생',
      ': 내 보상',
      ': 면책금 30만원, 휴차보상료 발생',
      ': 불가',
    ],
    xPosition: '23px',
  },
  {
    insurance: '고급자차 + 무제한특약',
    info: '안심하고 여행하고 싶다면',
    range: [
      ': 면책금 30만원',
      ': 면제',
      ': 무제한',
      ': 면책금 30만원, 휴차보상료 면제',
      ': 현장 출동 서비스 제공 (1회성 소멸)',
    ],
    xPosition: '38px',
  },
];

export const INSURANCE_INFO = [
  {
    title: '면책금',
    subs: [
      `사고시 운전자가 일정 금액을 부담해야 하는 수리 비용
      (종합 보험 접수 시 대인/대물/자손 각각 발생)`,
    ],
    items: [
      '수리비 20% (최저 30~50만원)\n면책금 30만원 발생',
      '면책금 30만원 발생',
      '면책금 30만원 발생',
    ],
  },
  {
    title: '휴차 보상료',
    subs: ['사고 발생 후 차량 수리 기간 동안 영업 손실 비용'],
    items: ['발생', '보상한도 초과 시 발생', '휴차 보상료 면제'],
  },
  {
    title: '보상 한도',
    subs: [
      '보험으로 처리 가능한 사고 비용의 최대 한도 비용\n(200~300만원 차종마다 상이)',
    ],
    items: ['한도 내 보상', '한도 내 보상', '무제한'],
  },
  {
    title: '단독 사고',
    subs: [
      '과실 유무와 상관없이 주.정차된 차량 및',
      '시설물을 접촉하거나 본인과실 100% 사고인 경우',
    ],
    items: [
      '수리비 20% (최저 30~50만원)\n면책금 30만원 발생\n휴차 보상료 발생',
      '면책금 30만원 발생\n휴차 보상료 발생',
      '면책금 30만원 발생\n휴차 보상료 면제',
    ],
  },
  {
    title: '휠/타이어 보장',
    subs: ['배터리, 사고 후 견인 10km까지 보장'],
    items: ['보장 불가', '보장 불가', '현장 출동 서비스 제공 (1회성 소멸)'],
  },
];
